import React from 'react';
import { Input } from '../shared/Input';
import i18n from '../../config/i18n';

const TextareaField = ({ field, form, ...restProps }) => (
  <Input {...field} {...restProps} multiline dir={i18n.dir()} />
);

export default React.memo(TextareaField);
